import { createAction } from "@reduxjs/toolkit";
export const lazyWidgetsLoaded = createAction("template/lazyWidgetsLoaded");
export const lazySectionLoaded = createAction("template/lazySectionLoaded");
export const lazySectionWithWidgetsLoaded = createAction("template/lazySectionWithWidgetsLoaded");
